/**
 * ConfirmDialog — small reusable MUI Dialog confirm primitive (WSRPDM-0018).
 * Used by MembersPanel (remove member) and InvitationsPanel (revoke
 * invitation) — the two destructive row actions this unit adds.
 */
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useCopy } from '@/hooks/useCopy';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  body: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  open,
  title,
  body,
  confirmLabel,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const { t } = useCopy();
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{body}</DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{t('tenantDetail.confirm.cancelButton', 'Cancel')}</Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          {confirmLabel ?? t('tenantDetail.confirm.confirmButton', 'Confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
